
<script>
  import { isArray, flatMapDeep } from 'lodash'
  import { mapState, mapActions } from 'vuex'

    export default {
        props: {
            show: {
                type: Array,
                default: function () {
                    return []
                }
            },
        },
    computed: {
        ...mapState(['messages']),
        hasSuccessMessage() {
            return this.messages.success !== ''
        },
        hasErrorMessages() {
            return this.show.hasOwnProperty('errors') && (
                typeof this.messages.error === 'object'
                && this.messages.error.length > 0
            )
        },
        hasWarningMessages() {
            return this.messages.warning !== ''
        },
        hasValidationMessages() {
            return this.messages.validation.length > 0
        },
        formatedErrorMessage() {
            return flatMapDeep(this.messages.error).map(msg => `• ${msg}`).join('<br>');
        },
        formatedValidationMessage() {
            return flatMapDeep(this.messages.validation).map(msg => `• ${msg}`).join('<br>')
        },
    },
    methods: {
        ...mapActions(['setMessage']),
        dismiss(type) {
            let obj
            if (type === 'error') {
                obj = { type, message: {} }
            } else if (type === 'validation') {
                obj = { type, message: {} }
            } else {
                obj = { type, message: '' }
            }
            this.setMessage(obj)
      },
    },
  }
</script>

<template>
  <div class="alerts">

    <el-alert
      :title="messages.success"
      v-show="hasSuccessMessage"
      type="success"
      @close="dismiss('success')"
      show-icon></el-alert>

    <el-alert
      :title="formatedErrorMessage"
      v-show="hasErrorMessages"
      type="error"
      @close="dismiss('error')"
      show-icon></el-alert>

    <el-alert
      :title="formatedValidationMessage"
      v-show="hasValidationMessages"
      type="warning"
      @close="dismiss('validation')"
      show-icon></el-alert>

    <el-alert
      :title="messages.warning"
      v-show="hasWarningMessages"
      type="warning"
      @close="dismiss('validation')"
      show-icon></el-alert>

  </div>
</template>

<style scoped>
  .alerts-container {
    padding-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// alerts.vue?6410e716